import { Component, OnDestroy, OnInit } from "@angular/core";
import { IntegratedAdmissionWizardService } from "../../service/integrated-admission-wizard.service";
import { IntegratedAdmissionAppointmentPlan } from "src/app/model/integrated-admission/integrated-admission-appointment-plan";
import { PracticeRegionSearchReservation } from "src/app/model/practice-region-reservation";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { ValorizationEdit } from "src/app/model/valorization-edit";
import { ValorizationItemAmount } from "src/app/model/valorization-item";
import { MatDialog } from "@angular/material";
import { ValorizationItemAmountEditDialogComponent } from "src/app/components/dialogs/valorization/valorization-item-amount-edit/valorization-item-amount-edit-dialog.component";
import { map, startWith } from "rxjs/operators";
import { IntegratedAdmissionAppointmentValidation } from "src/app/model/integrated-admission/integrated-admission-appointment-validation";

@Component({
  selector: "app-integrated-admission-appointment-valorization",
  templateUrl: "./integrated-admission-appointment-valorization.component.html",
  styleUrls: ["./integrated-admission-appointment-valorization.component.css"],
})
export class IntegratedAdmissionAppointmentValorizationComponent
  implements OnInit, OnDestroy
{
  valorizationEdit: ValorizationEdit;
  displayedColumns = ["name", "authorization", "amount", "star"];
  currentProceduresSubscription: Subscription;
  currentValorizationSubscription: Subscription;
  currentValidationSubscription: Subscription;
  currentLoadingValorizationSubscription: Subscription;
  readonlySubscription: Subscription;
  currentAppointmentSubscription: Subscription;
  proceduresValidationSubscription: Subscription;
  procedureValueChangesSubscription: Subscription;
  procedures: PracticeRegionSearchReservation[] = [];
  filterCompletePosiblePractices: Observable<PracticeRegionSearchReservation[]>;
  agreementPriceIdNoValidated: number[] = [];
  agreementPriceIdTransaction: number[] = [];

  loadingValorization: boolean = false;
  validated: boolean = false;
  plan: IntegratedAdmissionAppointmentPlan;
  form: FormGroup;
  readonly = false;

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private service: IntegratedAdmissionWizardService,
  ) {
    this.form = this.formBuilder.group({
      Procedure: [null],
    });

    this.subscribeEvents();
  }

  get items() {
    return this.valorizationEdit &&
      this.valorizationEdit.ValorizationAmount &&
      this.valorizationEdit.ValorizationAmount.ValorizationItemsAmount
      ? this.valorizationEdit.ValorizationAmount.ValorizationItemsAmount
      : [];
  }

  ngOnInit() {}


  changeText() {
    if (!this.procedures || this.procedures.length === 0) {
       this.service.loadProceduresForCurrentAppointment();
    }
  }

  private subscribeEvents() {
    this.currentProceduresSubscription =
      this.service.currentProceduresSubject$.subscribe((procedures) => {
        this.procedures = procedures;
      });

    this.currentValorizationSubscription =
      this.service.currentValorizationSubject$.subscribe((valorization) => {

        console.log("Valorization received: ", valorization);


        this.valorizationEdit = valorization;
      });

    this.currentLoadingValorizationSubscription =
      this.service.currentLoadingValorizationSubject$.subscribe((loading) => {
        this.loadingValorization = loading;
      });

    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readonly) => {
        if (readonly) {
          this.readonly = readonly;
        }
      },
    );

    this.currentAppointmentSubscription =
      this.service.currentAdmissionAppointment$.subscribe((appointment) => {
        this.agreementPriceIdNoValidated =
          appointment.ManualAgreementPriceIdNoValidated;
        if (!this.readonly) {
          this.readonly = appointment.ExistsCurrentInvoice;
        }
      });

    this.proceduresValidationSubscription = this.service.currentValidationProceduresSubject$.subscribe((procedures) => {
      if (procedures) {
        this.agreementPriceIdTransaction = procedures
          .filter((p) => p.AppliedRulesIds && p.AppliedRulesIds.length > 0)
          .map((p) => p.AgreementPriceId);
      } else {
        this.agreementPriceIdTransaction = [];
      }


      this.service.setManualAgreementPriceIdNoValidated(
        this.agreementPriceIdTransaction,
      );
    });

    this.currentValidationSubscription =
      this.service.currentValidationSubject$.subscribe((validation) => {
        if (
          validation &&
          (validation.AgreementPriceIdNoValidated ||
            validation.ManualAgreementPriceIdNoValidated ||
            validation.MedicalAppointmentValidation)
        ) {
          this.validated =
            validation.RequiredValidation &&
            validation.MedicalAppointmentValidation &&
            validation.MedicalAppointmentValidation.NeedCancel;

          this.agreementPriceIdNoValidated =
            validation.MedicalAppointmentValidation
              ? validation.MedicalAppointmentValidation
                  .AgreementPriceIdNoValidated
              : validation.AgreementPriceIdNoValidated;

          if (!this.agreementPriceIdNoValidated) {
            this.agreementPriceIdNoValidated =
              validation.ManualAgreementPriceIdNoValidated;
          }

          if (!this.agreementPriceIdNoValidated) {
            this.agreementPriceIdNoValidated = [];
          }
        }
      });

    this.filterCompletePosiblePractices =
      this.form.controls.Procedure.valueChanges.pipe(
        startWith<string | PracticeRegionSearchReservation>(""),
        map((value) =>
          typeof value === "string" ? value : value ? value.Name : "",
        ),
        map((name) => this.filterPosiblePractices(name)),
      );

    this.procedureValueChangesSubscription = this.form.controls.Procedure.valueChanges.subscribe((value) => {
      if (value && typeof value !== "string") {
        this.service.setProcedureSelected(value);
        this.form.patchValue(
          {
            Procedure: [null],
          },
          { emitEvent: false },
        );
      }
    });
  }

  getAuthorization(item: ValorizationItemAmount): string {
    return item.AuthorizationRequired ? "AUT" : "";
  }

  getName(item: ValorizationItemAmount): string {
    return (
      "(" +
      item.ValorizationItem.MedicalAppointmentProcedure.Code +
      "/" +
      item.Code +
      ") - " +
      (item.ValorizationItem.MedicalAppointmentProcedure
        .PracticeRegionAditionalId
        ? item.ValorizationItem.MedicalAppointmentProcedure
            .PracticeRegionAditionalName
        : item.ValorizationItem.MedicalAppointmentProcedure.PracticeRegionName)
    );
  }

  getQuantity(item: ValorizationItemAmount): number {
    return item.ValorizationItem.MedicalAppointmentProcedure.Quantity;
  }

  getPatientAmount(item: ValorizationItemAmount): number {
    return (
      this.getQuantity(item) * (item.PatientAmount + item.PatientTaxAmount)
    );
  }

  needExclude(item: ValorizationItemAmount): boolean {
    return (
      this.agreementPriceIdNoValidated &&
      this.agreementPriceIdNoValidated.includes(
        item.ValorizationItem.AgreementPriceId,
      )
    );
  }

  transactionApplied(item: ValorizationItemAmount): boolean {
    return (
      this.agreementPriceIdTransaction &&
      this.agreementPriceIdTransaction.includes(
        item.ValorizationItem.AgreementPriceId,
      )
    );
  }

  isExcluded(item: ValorizationItemAmount): boolean {
    return this.getQuantity(item) === 0;
  }

  public displayPosiblePracticesFn(
    item?: PracticeRegionSearchReservation,
  ): string | undefined {
    return item ? item.Name : undefined;
  }

  canRemove(item: ValorizationItemAmount): boolean {
    return (
      (this.needExclude(item) || !this.validated) &&
      item.ValorizationItem.MedicalAppointmentProcedure.Quantity > 0 &&
      !this.readonly
    );
  }

  canReverseRemove(item: ValorizationItemAmount): boolean {
    return (
      !this.validated &&
      item.ValorizationItem.MedicalAppointmentProcedure.Quantity == 0 &&
      !this.readonly
    );
  }

  canEdit(item: ValorizationItemAmount): boolean {
    return (
      !this.needExclude(item) &&
      !this.validated &&
      item.ValorizationItem.MedicalAppointmentProcedure.Quantity > 0 &&
      !this.readonly
    );
  }

  fromIA(item: ValorizationItemAmount): boolean {
    return item.ValorizationItem.MedicalAppointmentProcedure.FromIA;
  }

  getTotal(): number {
    return this.items.reduce(
      (total, item) => total + this.getPatientAmount(item),
      0,
    );
  }

  remove(item: ValorizationItemAmount) {
    this.service.removeValorizationItem(item);
  }

  reverseRemove(item: ValorizationItemAmount) {
    this.service.reverseRemoveValorizationItem(item);
  }

  edit(item: ValorizationItemAmount): void {
    const dialogRef = this.dialog.open(
      ValorizationItemAmountEditDialogComponent,
      {
        width: "50%",
        data: {
          item,
          noUpdateLikeParticular:
            !this.service.canRefreshPracticeToParticular(),
          noUpdateQuantity: true,
        },
      },
    );

    dialogRef.afterClosed().subscribe(async (value: any) => {
      if (value) {
        this.service.refreshValorizationItem(value.item, value.toParticular);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.currentProceduresSubscription) {
      this.currentProceduresSubscription.unsubscribe();
    }
    if (this.currentValorizationSubscription) {
      this.currentValorizationSubscription.unsubscribe();
    }
    if (this.currentLoadingValorizationSubscription) {
      this.currentLoadingValorizationSubscription.unsubscribe();
    }
    if (this.readonlySubscription) {
      this.readonlySubscription.unsubscribe();
    }
    if (this.currentAppointmentSubscription) {
      this.currentAppointmentSubscription.unsubscribe();
    }
    if (this.proceduresValidationSubscription) {
      this.proceduresValidationSubscription.unsubscribe();
    }
    if (this.currentValidationSubscription) {
      this.currentValidationSubscription.unsubscribe();
    }
    if (this.procedureValueChangesSubscription) {
      this.procedureValueChangesSubscription.unsubscribe();
    }
  }

  filterPosiblePractices(
    seachText?: string,
  ): PracticeRegionSearchReservation[] {
    return seachText
      ? this.procedures.filter(
          (option) =>
            option && this.coincideFilter(option, seachText.split(" ")),
        )
      : this.procedures
        ? this.procedures.slice()
        : [];
  }

  coincideFilter(
    practiceRegionSearchReservation: PracticeRegionSearchReservation,
    filters: string[],
  ): boolean {
    let response = true;
    filters.forEach((filter) => {
      if (
        filters.length === 1 &&
        practiceRegionSearchReservation.Code &&
        practiceRegionSearchReservation.Code === filter
      ) {
        response = true;
      } else if (
        response &&
        practiceRegionSearchReservation.SeachText.toLowerCase().indexOf(
          filter.toLowerCase(),
        ) < 0
      ) {
        response = false;
      }
    });

    return response;
  }
}
